/**
 * AuthButtons — sign in / sign out controls driven by the API's hosted AuthKit
 * flow (full-page redirects; the session lives in an HttpOnly cookie).
 */

import { useAppAuth } from "../../hooks/use-auth";
import { Button } from "@itoresearch/design-system";

/** Shown to signed-out users. */
export function SignInButtons() {
  const { signIn } = useAppAuth();

  return (
    <Button type="button" size="sm" onClick={() => signIn()}>
      Sign in
    </Button>
  );
}
